import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class transactionsComparison_template extends vnTemplate{

    protected getTemplateHtml(): string{

        return `             
             <div data-bind="visible: showComparison()">
             
               <div class="w-double-list-body" data-bind="style: { width: showReversal() ? '' : '100%'}">
                   
                   <div class="double-list-body" data-bind="with: originalTrx">
                   
                       <strong class="double-list-sub-title">Original Transaction</strong>
                       
                       <p class="double-list-text" style="font-weight: 700" data-bind="text: name"></p>
                       <dl class="double-list">
                           <dt><span>amount:</span></dt>
                           <dd><span data-bind="text: amount + '$'"></span></dd>
                           <dt><span>type:</span></dt>
                           <dd><span data-bind="text: type"></span></dd>
                           <dt><span>user:</span></dt>
                           <dd><span data-bind="text: user_fullName"></span></dd>
                           <dt><span>Article:</span></dt>
                           <dd><span data-bind="text: project_name"></span></dd>
                           <dt><span>creation type:</span></dt>
                           <dd><span data-bind="text: creation_type"></span></dd>
                           <dt><span>action type:</span></dt>
                           <dd><span data-bind="text: action_type"></span></dd>
                           <dt><span>entry type:</span></dt>
                           <dd><span data-bind="text: entry_type"></span></dd>
                           <dt><span>status:</span></dt>
                           <dd><span data-bind="text: status"></span></dd>
                       </dl>
                   </div>
               
                   <div class="double-list-body" data-bind="visible: showReversal()">
                   
                       <strong class="double-list-sub-title">Reverse Transaction</strong>
                       
                        <div class="" data-bind="with: reverseTrx">
                        
                           <p class="double-list-text" data-bind="text: name"></p>
                           <dl class="double-list">
                               <dt><span>amount:</span></dt>
                               <dd><span class="highlight" data-bind="text: amount + '$'"></span></dd>
                               <dt><span>type:</span></dt>
                               <dd><span class="highlight" data-bind="text: type"></span></dd>
                               <dt><span>user:</span></dt>
                               <dd><span data-bind="text: user_fullName"></span></dd>
                               <dt><span>Article:</span></dt>
                               <dd><span data-bind="text: project_name"></span></dd>
                               <dt><span>creation type:</span></dt>
                               <dd><span data-bind="text: creation_type"></span></dd>
                               <dt><span>action type:</span></dt>
                               <dd><span class="highlight" data-bind="text: action_type"></span></dd>
                               <dt><span>entry type:</span></dt>
                               <dd><span data-bind="text: entry_type"></span></dd>
                               <dt><span>status:</span></dt>
                               <dd><span class="highlight" data-bind="text: status"></span></dd>
                           </dl>
                        </div>
                   </div>
                   
                </div>
                
             </div>
            `;
    }

    protected getTemplateName(): string{
        return "transactionComparison-template";
    }

    protected getMainElementClasses(): Array<string>{
        return [];
    }

    protected buildViewModel(): any{

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return  {
             originalTrx: ko.observable(null)
            ,reverseTrx: ko.observable(null)
            ,showComparison: ko.observable(false)
            ,showReversal: ko.observable(false)
        };
    }

    public setOriginalTrx(trx, data){

        var project_name;
        if(trx.item != null){
            project_name = trx.item.title;
        }
        else{
            project_name = "N/A";
        }

        let originalTrx = {
             id: trx.id
            ,amount:  trx.amount
            ,name: trx.name
            ,user_fullName: data.user.valnet_user.fullName
            ,project_name: project_name
            ,creation_type : trx.creationType.name
            ,action_type : trx.actionType.name
            ,entry_type : trx.entryType.name
            ,status : trx.status.name
            ,type: trx.type.name
            ,idUser: trx.idUser
            ,idProject: trx.idItem
            ,idType: trx.idType
            ,idEntryType: trx.idEntryType
            ,dateScheduled: trx.dateScheduled

        };

        this.getTemplateViewModel().originalTrx(originalTrx);
    }

    public setReverseTrx(trx, data){

        var project_name;
        if(trx.item != null){
            project_name = trx.item.title;
        }
        else{
            project_name = "N/A";
        }

        let reverseTrx = {
             id: ""
            ,amount:  trx.amount
            ,name: trx.name
            ,user_fullName: data.user.valnet_user.fullName
            ,project_name: project_name
            ,creation_type : trx.creationType.name
            ,action_type : trx.actionType.name
            ,entry_type : trx.entryType.name
            ,status : trx.status.name
            ,type: trx.type.name
            ,idUser: trx.idUser
            ,idProject: trx.idItem
            ,idType: trx.idType
            ,idEntryType: trx.idEntryType
            ,dateScheduled: trx.dateScheduled
        };

        this.getTemplateViewModel().reverseTrx(reverseTrx);
    }

    public showComparison(){
        this.getTemplateViewModel().showComparison(true);
    }

    public showReversal(){
        this.getTemplateViewModel().showReversal(true);
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/transactionsComparison_template.ts